import { loadAndMigrateState, Migrator } from '@ps20-frontend/migrations';
import { IAppState } from '@ps20-frontend/apps/toolbar-store';
import { migrateRbdTreuebonus } from './2_migrate_treuebonus_rbd';
import { migrateAssekuranztarif } from './3_migrate_assekuranztarif';
import { migrateZahlungsoptionen } from './4_migrate_zahlungsoptionen';
import { migrateAktionsnachlass } from './5_migrate_aktionsnachlass';
import { migrateRbdTbForVorteilsrabatte } from './6_migrate_rdb_tb_to_vorteilsrabatt';
import { migrateUwToolbarFlags } from './9_migrate_uw_toolbar_flags';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: migrateRbdTreuebonus,
  },
  {
    toVersion: 3,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 4,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 5,
    migratorFunction: migrateAktionsnachlass,
  },
  {
    toVersion: 6,
    migratorFunction: migrateRbdTbForVorteilsrabatte,
  },
  {
    toVersion: 7,
    migratorFunction: migrateRbdTbForVorteilsrabatte,
  },
  {
    toVersion: 8,
    migratorFunction: migrateRbdTbForVorteilsrabatte,
  },
  {
    toVersion: 9,
    migratorFunction: migrateUwToolbarFlags,
  },
];

export const loadAndMigrateToolbarState = (
  currentState: IAppState,
  loadedState: { version: number },
) => loadAndMigrateState(currentState, loadedState, stateMigrators);
